
import React from 'react';

const Logo: React.FC<{ className?: string }> = ({ className = "w-8 h-8" }) => {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Row 1 */}
      <rect x="0" y="0" width="30" height="30" fill="#0091da" rx="1" />
      <rect x="35" y="0" width="30" height="30" fill="#facc15" rx="1" />
      <rect x="70" y="0" width="30" height="30" fill="#38bdf8" rx="1" />
      
      {/* Row 2 */}
      <rect x="0" y="35" width="30" height="30" fill="#7dd3fc" rx="1" />
      <rect x="35" y="35" width="30" height="30" fill="#38bdf8" rx="1" />
      <rect x="70" y="35" width="30" height="30" fill="#7dd3fc" rx="1" />
      
      {/* Row 3 */}
      <rect x="0" y="70" width="30" height="30" fill="#38bdf8" rx="1" />
      <rect x="35" y="70" width="30" height="30" fill="#facc15" rx="1" />
      <rect x="70" y="70" width="30" height="30" fill="#0091da" rx="1" />
    </svg>
  );
};

export default Logo;
